import { defineStore } from "pinia"
import { computed, ref } from "vue"

export interface MenuItem {
  id: string
  title: string
  /** Nama ikon Iconify, contoh `mdi:view-dashboard` */
  icon: string
  route: string
  /** Grup sidebar (judul grup menu), default `app` */
  group?: string
  children?: MenuItem[]
}

export const useMenuStore = defineStore("menu", () => {
  const isCollapsed = ref(false)
  /** Drawer navigasi samping (layar sempit) */
  const mobileDrawerOpen = ref(false)
  const activeMenu = ref("")

  const menuItems = computed<MenuItem[]>(() => [
    {
      id: "dashboard",
      title: "Dashboard",
      icon: "mdi:view-dashboard",
      route: "/admin/dashboard",
    },
    {
      id: "users",
      title: "Pengguna",
      icon: "mdi:account-group",
      route: "/admin/users",
    },
    {
      id: "staff",
      title: "Pengurus",
      icon: "mdi:account-tie",
      route: "/admin/staff",
    },
    {
      id: "videos",
      title: "Videos",
      icon: "mdi:video",
      route: "/admin/videos",
    },
    {
      id: "produksi",
      title: "Produksi Film",
      icon: "mdi:movie-open-outline",
      route: "/admin/produksi",
    },
    {
      id: "billing",
      title: "Harga & koin",
      icon: "mdi:cash-multiple",
      route: "/admin/billing",
    },
    {
      id: "comments",
      title: "Moderasi komentar",
      icon: "mdi:comment-alert-outline",
      route: "/admin/comments",
    },
    {
      id: "notifications",
      title: "Notifikasi",
      icon: "mdi:bell-outline",
      route: "/admin/notifications",
    },
    {
      id: "settings",
      title: "Settings",
      icon: "mdi:cog",
      route: "/admin/settings",
      group: "system",
    },
  ])

  function toggleCollapse(): void {
    isCollapsed.value = !isCollapsed.value
  }

  function toggleMobileDrawer(): void {
    mobileDrawerOpen.value = !mobileDrawerOpen.value
  }

  function closeMobileDrawer(): void {
    mobileDrawerOpen.value = false
  }

  function setActiveMenu(menuId: string): void {
    activeMenu.value = menuId
  }

  function setActiveByRoute(routePath: string): void {
    const item = menuItems.value.find((item) => item.route === routePath)
    if (item) {
      activeMenu.value = item.id
      return
    }
    const parent = menuItems.value.find(
      (i) => i.route !== "/" && routePath.startsWith(`${i.route}/`),
    )
    if (parent) {
      activeMenu.value = parent.id
    }
  }

  function initMenu(routePath: string): void {
    setActiveByRoute(routePath)
  }

  return {
    isCollapsed,
    mobileDrawerOpen,
    activeMenu,
    menuItems,
    toggleCollapse,
    toggleMobileDrawer,
    closeMobileDrawer,
    setActiveMenu,
    setActiveByRoute,
    initMenu,
  }
})
